'use client'
import Cal, { getCalApi } from '@calcom/embed-react'
import { useEffect, useRef, useState } from 'react'

// The Cal embed pulls ~1.7MB of third-party JS — eagerly mounting it makes it
// race the hero for first-load bandwidth. It mounts only when the booking
// section approaches the viewport (generous margin so it's ready by arrival).
export default function CalComEmbed({ namespace, calLink, ...props }) {
  const holderRef = useRef(null)
  const [nearViewport, setNearViewport] = useState(false)

  useEffect(() => {
    const el = holderRef.current
    if (!el) return
    if (!('IntersectionObserver' in window)) {
      setNearViewport(true)
      return
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setNearViewport(true)
          io.disconnect()
        }
      },
      { rootMargin: '1200px' },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  useEffect(() => {
    if (!nearViewport) return
    ;(async function () {
      const cal = await getCalApi({ namespace })
      cal('ui', { theme: 'dark', hideEventTypeDetails: false, layout: 'month_view' })
    })()
  }, [nearViewport, namespace])

  if (!nearViewport) {
    return <div ref={holderRef} style={{ width: '100%', height: '100%' }} aria-hidden />
  }

  return (
    <Cal
      namespace={namespace}
      calLink={calLink}
      style={{ width: '100%', height: '100%', overflow: 'scroll' }}
      config={{ layout: 'month_view', useSlotsViewOnSmallScreen: 'true', theme: 'dark' }}
      {...props}
    />
  )
}
